import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useCallback } from 'react';
import { Grid, InputAdornment, Typography } from '@mui/material';
import { NullableNumberInput } from 'console/shared/components/fields';
import { ControlWithoutLabel } from 'console/shared/components/fields/control/without-label';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
const NTCSensorRow = memo(function NTCSensorRow(props) {
    const { temperature, name, validation, tab_key, shift, sensors, onChangeState, index, } = props;
    const shift_validation = unpack_validation(validation, 'shift');
    const onChangeSensorShift = useCallback((shift) => {
        //@ts-ignore
        //Делегированые методы из прототипа не могут передаваться в пропсы?
        const new_sensors = sensors.update(index, (sensor) => ({
            ...sensor,
            shift: String(shift),
        }));
        onChangeState(tab_key, { sensors: new_sensors });
    }, [tab_key, sensors]);
    return (_jsxs(Grid, { container: true, item: true, columnSpacing: 2, children: [_jsx(Grid, { item: true, xs: 4, children: _jsx(Typography, { children: name }) }), _jsx(Grid, { item: true, xs: 4, children: _jsx(Typography, { children: temperature }) }), _jsx(Grid, { item: true, xs: 4, children: _jsx(ControlWithoutLabel, { validation_result: shift_validation, validation_warnings_result: null, value: shift, onChange: onChangeSensorShift, field: (input_props) => (_jsx(NullableNumberInput, { min: -5, max: 5, step: 1, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u00B0C" }), ...input_props })) }) })] }));
});
export { NTCSensorRow };
